<template>
    <div>
        <action-bar>
            <router-link :to="{name: 'tag-create'}">Neuen Tag erstellen</router-link>
        </action-bar>
        <main class="content">
            <h1>Tags</h1>
            <table class="table table-striped" v-if="tags !== false">
                <thead>
                <tr>
                    <th>Title</th>
                    <th class="text-right">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(tag, index) in tags">
                    <td>{{tag.name.text}}</td>
                    <td class="text-right">
                        <a href="#" v-confirm="{
                            html: true,
                            ok: dialog => remove(dialog, tag),
                            message: 'Bist du sicher, dass du den Tag <strong>'+tag.name.text+'</strong> löschen möchtest?'}"><i
                                class="fa fa-trash fa-fw"></i></a>
                        <router-link :to="{name: 'tag-edit', params: {tagId: tag.id}}"><i class="fa fa-edit fa-fw"></i>
                        </router-link>
                    </td>
                </tr>
                </tbody>
            </table>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
export default {
  asyncComputed: {
    tags() {
      return axios
        .get("/api/" + store.state.language + "/tag/list")
        .then(({ data }) => {
          return data.result;
        });
    }
  },
  methods: {
    remove(dialog, tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
      axios.post("/api/" + store.state.language + "/tag/" + tag.id + "/delete");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/tag/List.vue